<template>
  <nav>
    <AlertMessages
      v-if="alertValue"
      :alert-type="alertType"
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />
    <v-row
      v-if="(!surveys || surveys.length == 0) && surveysInfo.currentPage == 1 && !loadingData"
      align="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="6"
        offset-sm="2"
        offset-md="3"
        align="center"
      >
        <EmptyPage
          :page-title="$t('emptySurveysInActivityTitle')"
          :page-text="$t('emptySurveysInActivityText')"
          page-image="image5"
        />
      </v-col>
    </v-row>
    <v-row
      v-else
      align="center"
      class="mx-auto mt-5"
      :class="mobile() ? 'pa-3' : ''"
    >
      <v-col
        :cols="mobile() ? '12' : '11'"
        class="mx-auto px-0"
      >
        <v-card
          v-for="survey in surveys"
          :key="survey.id"
          rounded="xxl"
          class="my-2 solo"
          @click="showSummarySurveyDetail(survey.id)"
        >
          <v-hover>
            <v-row
              slot-scope="{ hover }"
              no-gutters
              :class="`py-4 elevation-${hover? 8 : 2 }`"
            >
              <v-col
                cols="12"
                class="px-6"
              >
                <div class="text-body-2 grey--text justify-left">
                  {{ $t('title') }}
                </div>
                <div class="text-body-1 darktext--text">
                  {{ survey.attributes.title }}
                </div>
              </v-col>
            </v-row>
          </v-hover>
        </v-card>
      </v-col>
    </v-row>
    <Pagination
      v-model="pageNumber"
      class="mb-16"
      circle
      :data-length="surveysInfo.total"
      :page-number="surveysInfo.currentPage"
      total-visible="5"
      :size="size"
      @input="handlePageChange"
      :key="paginationKey"
    />
  </nav>
</template>
<script>
import i18n from '../../plugins/i18n'
import { getSurveysInActivity } from '../../api/activityApi'
import Pagination from '../../components/Pagination'
import EmptyPage from '../../components/EmptyPage'
import { repeatedMethodsMixin } from '../../mixins/repeatedMethodsMixin'
import AlertMessages  from '../../components/AlertMessages'

export default {
    components: {
        Pagination,
        EmptyPage,
        AlertMessages
    },
    mixins: [repeatedMethodsMixin],
    data(){
        return{
            surveys: [],
            surveysInfo: {
                currentPage: 1,
                total: 0,
            },
            surveyId: window.$cookies.get('id'),
            activityId: this.$route.params.id,
            spaceId: window.$cookies.get('space_id'),
            error:'',
            alertMsg:'',
            alertType:'',
            alertValue:false,
            pageNumber: 1,
            size: 15,
            loadingData: false,
            link: {title: '', route: '/activity/' + this.$route.params.id + '/owners/add'},
            isLoading:false,
            paginationKey: ''
        }
    },
    computed: {
      productPlan() {
        return this.$store.state.productPlan;
      },
    },
    async created(){
        this.loadingData = true
        await this.fetchSurveysInActivity()
        this.loadingData = false
    },
    methods:{
        handlePageChange(value){
            this.surveysInfo.currentPage = value
            this.pageNumber = value
            this.fetchSurveysInActivity()
        },
        showSummarySurveyDetail(id){
            this.$router.push({path: '/activity/' + this.activityId + '/survey/' +id+'/summary' })
        },
        async fetchSurveysInActivity(){
            try {
                const response = await getSurveysInActivity(this.activityId, this.pageNumber, this.size)
                if(response.status){
                    if(response.status == 200) {
                        this.surveys = response.data.data
                        window.scrollTo(0,0)
                        this.surveysInfo = response.data.meta.page
                    }
                }
            } catch (e) {
                if(e.response){
                    this.alertValue = true
                    if(e.response.status == 403){
                        this.$router.push({name: 'PageAccessDenied'})
                    } else if(e.response.status == 404) {
                         this.$router.push({name: 'PageNotFound'})
                    } else {
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('serverError')
                    }
                }
            }
        }
    }
}
</script>